import { render } from "./halfFullSizeWrapper.vue?vue&type=template&id=386ebb0c"
import script from "./halfFullSizeWrapper.vue?vue&type=script&lang=js"
export * from "./halfFullSizeWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__